<template>
    <!-- 订单管理/创建派对订单 -->
    <content-view>
        <div class="create-party-order">
            <a-spin :spinning="spinning">
                <a-form :form="form">
                    <a-card title="基础信息" class="mb16">
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="客户名称">
                                    <a-input :disabled="isEdit" v-decorator="['customerName', {rules: [{required: true, message: '请输入'}, {pattern: /^.{0,10}$/, message: '不能超过10个字符'}]}]" placeholder="请输入"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="客户手机号">
                                    <a-input :disabled="isEdit" style="width: 100%;" v-decorator="['customerPhone', {rules: [{required: true, message: '请输入'}]}]" placeholder="请输入"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="派对负责人">
                                    <a-input v-decorator="['partyStaff', {rules: [{required: true, message: '请输入'}, {pattern: /^.{0,10}$/, message: '不能超过10个字符'}]}]" placeholder="请输入"></a-input>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="销售类型">
                                    <a-select :disabled="isEdit" style="width: 100%;" allowClear :options="$commonOptions.partySellTypeOptions" v-decorator="['sellType', {rules: [{required: true, message: '请选择'}]}]" placeholder="请输入"></a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="15" :offset="1">
                                <a-form-item label="备注">
                                    <a-input v-decorator="['remark', {rules: [{pattern: /(^.{0}$)|(^.{10,50}$)/, message: '请输入备注，10-50字'}]}]" placeholder="请输入备注，10-50字"></a-input>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-card>
                    <a-card title="派对信息" class="mb16">
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="派对日期">
                                    <a-date-picker style="width: 100%;" v-decorator="['partyDate', {rules: [{required: true, message: '请选择'}]}]" placeholder="请选择"></a-date-picker>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="派对时间" class="no-margin_bottom">
                                </a-form-item>
                                <a-input-group compact>
                                    <a-form-item class="group-left" style="display: inline-block; width: 45%;">
                                        <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['partyStartTime']" placeholder="开始时间">
                                            <span slot="suffixIcon"></span>
                                        </a-time-picker>
                                    </a-form-item>
                                    <a-input
                                        style="width: 10%; border-left: 0;border-right: 0; pointer-events: none; backgroundColor: #fff"
                                        placeholder="~"
                                        disabled
                                    />
                                    <a-form-item class="group-right" style="display: inline-block; width: 45%;">
                                        <a-time-picker format="HH:mm" style="width: 100%;" v-decorator="['partyEndTime']" placeholder="结束时间"></a-time-picker>
                                    </a-form-item>
                                </a-input-group>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="派对门店">
                                    <a-select :disabled="isEdit" style="width: 100%;" allowClear :options="shopList" v-decorator="['shopId', {rules: [{required: true, message: '请选择'}, {pattern: /^.{0,10}$/, message: '不能超过10个字符'}]}]" placeholder="请输入"></a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="派对成人数">
                                    <a-input-number style="width: 100%;" v-decorator="['adultNum', {rules: [{required: true, message: '请输入'}, {pattern: /^\d*$/, message: '请输入'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="派对宝宝数">
                                    <a-input-number style="width: 100%;" v-decorator="['babyNum', {rules: [{required: true, message: '请输入'}, {pattern: /^\d*$/, message: '请输入'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="派对类型">
                                    <a-select style="width: 100%;" allowClear :options="$commonOptions.partyTypeOpitons" v-decorator="['partyType', {rules: [{required: true, message: '请选择'}, {pattern: /^.{0,10}$/, message: '不能超过10个字符'}]}]" placeholder="请输入"></a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="7" class="party-theme-col">
                                <a-form-item label="派对主题">
                                    <a-input @focus="themeFocus" @blur="themeBlur" @change="themeChange" style="width: 100%;" v-decorator="['partyTitle', {rules: [{pattern: /^.{0,20}$/, message: '不能超过20个字符'}]}]" placeholder="请输入，不超过20字"></a-input>
                                </a-form-item>
                                <div class="party-theme-container" v-if="themeList.length > 0">
                                    <div class="party-theme-wrapper">
                                        <div @click="setThemeVal(item)" class="party-theme-item" v-for="item in themeList" :key="item">
                                            {{item}}
                                        </div>
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                        <div class="font-weight mb16">派对主人公</div>
                        <a-table
                        bordered
                        :columns="columns"
                        :dataSource="dataSource"
                        :pagination="false"
                        :rowKey="i => i.key"
                        >
                            <template slot="babyName" slot-scope="key, row, index">
                                <a-form-item class="no-margin_bottom">
                                    <a-input @change="memberValueChange($event, 'babyName', index)" v-decorator="[`babyName[${index}]`, {initialValue: key, rules: [{required: true, message: '请输入'}, {pattern: /^.{0,10}$/, message: '不能超过10个字符'}]}]" placeholder="请输入"></a-input>
                                </a-form-item>
                            </template>
                            <template slot="babyGender" slot-scope="key, row, index">
                                <a-form-item class="no-margin_bottom">
                                    <a-select :options="genderOptions" @change="memberValueChange($event, 'babyGender', index)" v-decorator="[`babyGender[${index}]`, {initialValue: key}]" placeholder="请选择"></a-select>
                                </a-form-item>
                            </template>
                            <template slot="babyBirthday" slot-scope="key, row, index">
                                <a-form-item class="no-margin_bottom">
                                    <a-date-picker @change="memberValueChange($event, 'babyBirthday', index)" style="width: 100%;" v-decorator="[`babyBirthday[${index}]`, {initialValue: key}]" placeholder="请选择"></a-date-picker>
                                </a-form-item>
                            </template>
                            <template slot="withConsumer" slot-scope="key, row, index">
                                <a-form-item class="no-margin_bottom">
                                    <a-select :options="withConsumerOptions" @change="memberValueChange($event, 'withConsumer', index)" v-decorator="[`withConsumer[${index}]`, {initialValue: key}]" placeholder="请选择"></a-select>
                                </a-form-item>
                            </template>
                            <template slot="action" slot-scope="key, row, index">
                                <a class="text-primary" @click="delMember(index)">删除</a>
                            </template>
                        </a-table>
                        <div class="add-member-btn" @click="addMember">
                            <a-icon type="plus"></a-icon>
                            新增成员
                        </div>
                    </a-card>
                    <a-card title="基础信息" class="mb16">
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="票券预售金额（元）">
                                    <a-input-number style="width: 100%;" v-decorator="['ticketPresell', {rules: [{required: true, message: '请选择'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '收款金额需大于等于0,且最多保留两位小数'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="餐饮预售金额（元）">
                                    <a-input-number style="width: 100%;" v-decorator="['cateringPresell', {rules: [{required: true, message: '请选择'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '收款金额需大于等于0,且最多保留两位小数'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                            <a-col :span="7" :offset="1">
                                <a-form-item label="装饰预售金额（元）">
                                    <a-input-number style="width: 100%;" v-decorator="['decoratePresell', {rules: [{required: true, message: '请选择'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '收款金额需大于等于0,且最多保留两位小数'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="7">
                                <a-form-item label="增值服务预售金额（元）">
                                    <a-input-number style="width: 100%;" v-decorator="['servicePresell', {rules: [{required: true, message: '请选择'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '收款金额需大于等于0,且最多保留两位小数'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-card>
                </a-form>
                <div class="btn-bar text-right">
                    <a-popconfirm
                        title="取消后所有信息不会保存，是否确认取消？"
                        ok-text="确认"
                        cancel-text="取消"
                        @confirm="back"
                    >
                        <a-button :loading="submitLoading">取消</a-button>
                    </a-popconfirm>
                    <a-popconfirm
                        title="是否确认提交？"
                        ok-text="确认"
                        cancel-text="取消"
                        @confirm="submit"
                    >
                        <a-button :loading="submitLoading" type="primary">确定</a-button>
                    </a-popconfirm>
                </div>
            </a-spin>
        </div>
    </content-view>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: '宝宝姓名',
            width: '22.5%',
            dataIndex: 'babyName',
            scopedSlots: {customRender: 'babyName'}
        },
        {
            title: '宝宝性别',
            width: '22.5%',
            dataIndex: 'babyGender',
            scopedSlots: {customRender: 'babyGender'}
        },
        {
            title: '宝宝生日',
            width: '22.5%',
            dataIndex: 'babyBirthday',
            scopedSlots: {customRender: 'babyBirthday'}
        },
        {
            title: '宝宝与客户关系',
            width: '22.5%',
            dataIndex: 'withConsumer',
            scopedSlots: {customRender: 'withConsumer'}
        },
        {
            title: '操作',
            width: '10%',
            dataIndex: 'key',
            scopedSlots: {customRender: 'action'}
        },
    ];
    const genderOptions = [
        {
            label: '男',
            value: '男'
        },
        {
            label: '女',
            value: '女'
        }
    ];
    const withConsumerOptions = [
        {
            label: '爸爸',
            value: '爸爸'
        },
        {
            label: '妈妈',
            value: '妈妈'
        },
        {
            label: '叔叔',
            value: '叔叔'
        },
        {
            label: '阿姨',
            value: '阿姨'
        },
        {
            label: '爷爷',
            value: '爷爷'
        },
        {
            label: '奶奶',
            value: '奶奶'
        },
        {
            label: '外公',
            value: '外公'
        },
        {
            label: '外婆',
            value: '外婆'
        },
        {
            label: '其他',
            value: '其他'
        }
    ];
    export default {
        name: "createPartyOrder",
        components: {
        },
        props: {},
        data() {
            return {
                columns,
                genderOptions,
                withConsumerOptions,
                dataSource: [],
                themeList: [],
                submitLoading: false,
                shopList: [],
                spinning: false,
                isEdit: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            $route(val) {
                this.getDetail();
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getShopList();
            let loginInfo = this.$userInfoTool.getUser();
            if (this.$route.name === 'editPartyOrder') {
                this.isEdit = true;
                this.getDetail();
            } else {
                let shopId = loginInfo.shopIdList[0];
                this.form.setFieldsValue({
                    partyStaff: loginInfo.name,
                    shopId: shopId !== '-1' ? shopId : undefined
                });
            }
        },
        methods: {
            /**
             * @func getShopList 获取所有门店
             */
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    let shopIdList = this.$userInfoTool.getUser().shopIdList;
                    this.shopList = res.filter(i => {
                        i.label = i.name;
                        i.value = i.id;
						return shopIdList.find($i => {
							return $i === i.id;
						})
					});
                    if (shopIdList.find(el => el == -1)) {
                        this.shopList = res;
                        return;
                    }
                });
            },
            /**
             * @func partyOrderGetTitle 获取历史主题
             */
            partyOrderGetTitle(word) {
                this.$api.order.partyOrderGetTitle({
                    query: {
                        like: word
                    }
                }).then(res => {
                    this.themeList = res;
                });
            },
            /**
             * @func getDetail 获取订单详情
             */
            getDetail() {
                let orderId = this.$route.params.orderId;
                if (!Boolean(orderId)) {
                    this.back();
                }
                this.spinning = true;
                this.$api.order.partyOrderDetail({
                    params: {
                        id: orderId
                    }
                }).then(res => {
                    let {
                        customerName,
                        customerPhone,
                        partyStaff,
                        sellType,
                        remark,
                        partyDate,
                        partyStartTime,
                        partyEndTime,
                        shopId,
                        adultNum,
                        babyNum,
                        partyType,
                        partyTitle,
                        ticketPresell,
                        cateringPresell,
                        decoratePresell,
                        servicePresell,
                        partyOrderBabyVoList
                    } = res;
                    this.dataSource = partyOrderBabyVoList.map((i, index) => {
                        return ({
                            key: index,
                            babyName: i.name,
                            babyGender: i.gender || undefined,
                            babyBirthday: Boolean(i.birthday) ? this.$moment(i.birthday) : undefined,
                            withConsumer: i.withConsumer || undefined
                        });
                    });
                    this.form.setFieldsValue({
                        customerName,
                        customerPhone,
                        partyStaff,
                        sellType,
                        remark,
                        partyDate: this.$moment(partyDate),
                        partyStartTime: Boolean(partyStartTime) ? this.$moment(partyDate + ' ' + partyStartTime) : undefined,
                        partyEndTime: Boolean(partyEndTime) ? this.$moment(partyDate + ' ' + partyEndTime) : undefined,
                        shopId,
                        adultNum,
                        babyNum,
                        partyType,
                        partyTitle,
                        ticketPresell,
                        cateringPresell,
                        decoratePresell,
                        servicePresell
                    });
                    this.spinning = false;
                });
            },
            /**
             * @func themeChange 派对主题输入框输入回调
             */
            themeChange(e) {
                let val = e.target.value;
                this.partyOrderGetTitle(val);
            },
            /**
             * @func themeFocus 派对主题输入框获取焦点
             */
            themeFocus(e) {
                let val = e.target.value;
                this.partyOrderGetTitle(val);
            },
            /**
             * @func themeBlur 派对主题输入框失去焦点
             */
            themeBlur(e) {
                setTimeout(() => {
                    this.themeList = [];
                }, 300);
            },
            /**
             * @func setThemeVal 派对主题推荐填入
             */
            setThemeVal(val) {
                this.form.setFieldsValue({
                    partyTitle: val
                });
                this.themeList = [];
            },
            /**
             * @func addMember 新增派对成员
             */
            addMember() {
                this.dataSource.push({
                    key: this.$moment().valueOf()
                });
            },
            /**
             * @func delMember 删除派对成员
             */
            delMember(index) {
                this.dataSource.splice(index, 1);
            },
            /**
             * @func memberValueChange 派对成员数据绑定到dataSource
             */
            memberValueChange(val, key, index) {
                if(key === 'babyName') {
                    this.dataSource[index][key] = val.target.value;
                } else {
                    this.dataSource[index][key] = val;
                }
            },
            /**
             * @func dataFormat 提交数据序列化
             */
            dataFormat(values) {
                values.partyStartTime = Boolean(values.partyStartTime) ? values.partyStartTime.format('HH:mm') : undefined;
                values.partyEndTime = Boolean(values.partyEndTime) ? values.partyEndTime.format('HH:mm') : undefined;
                values.partyDate = values.partyDate.format('YYYY-MM-DD');
                values.shopName = this.shopList.find(i => i.id === values.shopId).name;
                if (values.babyName && Array.isArray(values.babyName)) {
                    values.partyOrderBabyDtoList = values.babyName.map((i ,index) => {
                        return ({
                            birthday: Boolean(values.babyBirthday[index]) ? values.babyBirthday[index].format('YYYY-MM-DD') : undefined,
                            gender: values.babyGender[index] || undefined,
                            name: i,
                            withConsumer: values.withConsumer[index] || undefined
                        });
                    })
                } else {
                    values.partyOrderBabyDtoList = [];
                }
                delete values.babyName;
                delete values.babyGender;
                delete values.babyBirthday;
                delete values.withConsumer;
                return values;
            },
            /**
             * @func submit 提交
             */
            submit() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors) || this.submitLoading) {
                        return false;
                    }
                    let routeName = this.$route.name;
                    let reqData = this.dataFormat(this.$utils.deepClone(values));
                    if (routeName === 'editPartyOrder') {
                        reqData.id = this.$route.params.orderId;
                    }
                    let apiName = routeName === 'createPartyOrder' ? 'partyOrderCreate' : 'partyOrderUpdate';
                    this.submitLoading = true;
                    this.$api.order[apiName]({
                        body: {
                            ...reqData
                        }
                    }).then(res => {
                        this.submitLoading = false;
                        this.$message.success('操作成功！');
                        setTimeout(() => {
                            this.back();
                        }, 300);
                    }).catch(err => {
                        this.submitLoading = false;
                    });
                });
            },
            /**
             * @func back 取消
             */
            back() {
                this.$router.back();
            }
        }
    };
</script>
<style lang="scss">
.create-party-order {
    .ant-input-group-compact {
        .group-left {
            .ant-time-picker-input {
                border-right: none;
                border-radius: 4px 0 0 4px;
            }
        }
        .group-right {
            .ant-time-picker-input {
                border-left: none;
                border-radius: 0 4px 4px 0;
            }
        }
    }
    .add-member-btn {
        color: #666;
        border: 1px dashed #999;
        text-align: center;
        padding: 8px 0;
        margin-top: 16px;
        user-select: none;
        cursor: pointer;
        border-radius: 3px;
    }
    .party-theme-col {
        position: relative;
        .party-theme-container {
            position: absolute;
            width: 100%;
            height: 300px;
            background: #fff;
            z-index: 99;
            top: 70px;
            border-radius: 4px;
            border: 1px solid #ddd;
            overflow-y: scroll;
            .party-theme-item {
                padding: 16px 10px 0 16px;
                &:after {
                    content: "";
                    display: block;
                    margin-left: -8px;
                    padding-top: 10px;
                    border-bottom: 1px solid #ddd;
                }
                &:hover {
                    background: rgba(253, 107, 2, 0.2);
                }
            }
        }
    }
    .btn-bar {
        padding: 14px 24px;
        background: #ffffff;
        border-top: 1px solid #dddddd;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 9;
    }
}
</style>